import * as React from 'react'

interface IProps {
  onError(error: Error, info: React.ErrorInfo): void
  children: React.ReactNode
}

interface IState {
  hasFailed: boolean
}

// Share map fails alone: a chunk that will not load or a render that throws closes the sheet
// instead of taking the whole Workflows route down with it.
export default class MapExportSheetBoundary extends React.Component<
  IProps,
  IState
> {
  public state: IState = { hasFailed: false }

  public static getDerivedStateFromError(): IState {
    return { hasFailed: true }
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.props.onError(error, info)
  }

  public render(): React.ReactNode {
    return this.state.hasFailed ? null : this.props.children
  }
}
